const selection = window?.selection;

const copyToClipboard = {
  init: function() {
    const self = this;
    const sharingBanners = document.getElementsByClassName('social-sharing-banner');

    if (sharingBanners.length) {
      for (const banner of sharingBanners) {
        const copyButton = banner.getElementsByClassName('copy-to-clipboard')[0],
          hiddenUrlElement = banner.getElementsByClassName('current-page-url')[0];

        copyButton.addEventListener('click', function(event) {
          event.target.classList.add('show-tooltip');
          self._copyUrl(hiddenUrlElement);

          setTimeout(function () {
            event.target.classList.remove('show-tooltip');
          }, 2000);
        });
      }
    }
  },

  _copyUrl: function(hiddenUrlElement) {
    if (document.body.createTextRange) { //IE
      const range = document.body.createTextRange();

      range.moveToElementText(hiddenUrlElement);
      range.select();
      document.execCommand('Copy');

      setTimeout(function () {
        selection.removeAllRanges();
      }, 1000);
    }
    else if (window.getSelection) { //Mozilla, Opera, WebKit
      const selection = window.getSelection();
      const range = document.createRange();

      range.selectNodeContents(hiddenUrlElement);
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand('Copy');

      setTimeout(function () {
        selection.removeAllRanges();
      }, 1000);
    }
  }
};

export default copyToClipboard;
